<template>
  <a-card :bordered="false">
    <div>
      <a-form :form="form" >
        <a-form-item label="系统编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['number']" disabled/>
        </a-form-item>
        <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['name', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="名称"/>
        </a-form-item>
        <a-form-item label="参与人" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            mode="multiple"
            label-in-value
            v-decorator="[
              'participant_ids',
              {
                rules: [
                  { required: true, message: '必填项，请输入交易品种' },
                ],
              },
            ]"
            placeholder="参与人"
            :filter-option="false"
            :not-found-content="fetching ? undefined : null"
            @search="this.userSearch"
          >
            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
            <a-select-option v-for="d in userList" :key="d.participant_id ? d.participant_id: d.user_id">
              <span v-if="d.nickname">{{ d.nickname }}</span>
              <span v-else-if="d.name">{{ d.name }}</span>
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="负责人" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            show-search
            v-decorator="[
              'leader_id',
              {
                rules: [
                  { required: true, message: '必填项，请输入负责人' },
                ],
              },
            ]"
            placeholder="负责人"
            style="width: 100%"
            :filter-option="false"
            :not-found-content="leaderFetching ? undefined : null"
            @search="this.userLeaderSearch"
          >
            <a-spin v-if="leaderFetching" slot="notFoundContent" size="small" />
            <a-select-option v-for="d in userLeaderList" :key="d.user_id">
              {{ d.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-if="false" label="信用" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number :precision="2" style="width: 50%" v-decorator="['credit', {rules: [{required: true, message: '必填项，请填写信息'}]}]" />
        </a-form-item>
        <a-form-item v-if="false" label="现金" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number :precision="2" style="width: 50%" v-decorator="['cash', {rules: [{required: true, message: '必填项，请填写信息'}]}]" />
        </a-form-item>
        <a-form-item label="金蝶业务号编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['jd_code', {rules: [{required: true, message: '必填项，请填写信息'}, {max:64, message: '输入超出长度限制'}]}]" />
        </a-form-item>
        <a-form-item v-if="false" label="起止时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-range-picker
            @change="onDateChange"
            v-decorator="['date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
          />
        </a-form-item>
        <a-form-item label="待落实前提条件" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea v-decorator="['precondition', {rules: [{required: false, message: '必填项，请填写信息'}, {max:256, message: '输入超出长度限制'}]}]" :auto-size="{ minRows: 2, maxRows: 3 }" placeholder="待落实前提条件"/>
        </a-form-item>
        <a-form-item v-bind="buttonCol">
          <a-row>
            <a-col span="6">
              <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
            </a-col>
            <a-col span="10">
              <a-button @click="handleGoBack">返回</a-button>
            </a-col>
            <a-col span="8"></a-col>
          </a-row>
        </a-form-item>
      </a-form>
    </div>
  </a-card>
</template>

<script>
import moment from 'moment'
import pick from 'lodash.pick'
import { project_update, project_list } from '@/api/trade_project'
import debounce from 'lodash/debounce'
import { tradeUserList } from '@/api/trade_user'
const fields = ['number', 'name', 'credit', 'cash', 'date', 'ship_name', 'precondition', 'participant_ids', 'leader_id', 'jd_code']
export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    this.userSearch = debounce(this.handleUserSearch, 800)
    this.userLeaderSearch = debounce(this.handleUserLeaderSearch, 800)
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      id: 0,
      data: {},
      dateFormat: 'YYYY-MM-DD',
      start_date: '',
      end_date: '',
      loading: false,
      date_change: false,
      fetching: false,
      leaderFetching: false,
      userList: [],
      userLeaderList: []
    }
  },
  mounted () {
    fields.forEach(v => this.form.getFieldDecorator(v))
    console.log('-------------------', this.$route.params.id)
    this.loading = true
    project_list({ id: this.$route.params.id })
      .then(res => {
        console.log(res.data, '我是数据列表@')
        const list = res.data.entries
        if (list && list.length > 0) {
          this.data = list[0]
          this.id = this.data.id
          if (this.data.start_date === '1970-01-01') {
            this.start_date = ''
          } else {
            this.start_date = moment(this.data.start_date, this.dateFormat)
          }
          if (this.data.end_date === '1970-01-01') {
           this.end_date = ''
          } else {
            this.end_date = moment(this.data.end_date, this.dateFormat)
          }
          if (this.data.participants) {
            this.data.participant_ids = this.data.participants.map(item => {
              return {
                key: item['participant_id'] ? item['participant_id'] : item['user_id'],
                value: item['nickname'] ? item['nickname'] : item['name']
              }
            })
            this.userList = this.data.participants.map(item => {
              return {
                user_id: item['participant_id'] ? item['participant_id'] : item['user_id'],
                nickname: item['nickname'] ? item['nickname'] : item['name']
              }
            })
          }
          console.log(this.data.leader)
          if (this.data.leader) {
            this.userLeaderList = [
              {
                user_id: this.data['leader_id'],
                name: this.data['leader']
              }
            ]
          }
          this.data.date = [this.start_date, this.end_date]
          console.log('参与人数据', this.data)
          this.form.setFieldsValue(pick(this.data, fields))
        }
      }).finally(() => {
        this.loading = false
    })
  },
  methods: {
    moment,
    handleGoBack () {
      // this.$emit('onGoBack')
      this.$router.go(-1)
    },
    handleUserSearch (value) {
      // user_list({ nickname: value }).then((res) => {
      //   const result = res.data.entries || []
      //   this.userList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      // })
      tradeUserList({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.userList = result
      }).finally(() => {
        this.fetching = false
      })
    },
    handleUserLeaderSearch (value) {
      if (value === undefined || value === '') {
        return
      }
      this.leaderFetching = true
      this.userLeaderList = []
      tradeUserList({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.userLeaderList = result
      }).finally(() => {
        this.leaderFetching = false
      })
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        console.log('我要提交接口', values)
        if (!err) {
          if (this.date_change) {
            values.start_date = this.start_date
            values.end_date = this.end_date
          } else {
            values.start_date = this.data.start_date
            values.end_date = this.data.end_date
          }
          values.date = undefined
          values.participant_ids = values.participant_ids.map(item => {
            return item['key']
          })
          this.loading = true
          project_update(values, this.id)
            .then((res) => {
              if (res.code === 1000) {
                this.handleGoBack()
                console.log(res, '修改成功')
              }
            }).finally(() => {
              this.loading = false
          })
        }
      })
    },
    loadEditInfo (data) {
      const { form } = this
      console.log(`将加载 ${this} 信息到表单`)
      new Promise((resolve) => {
        setTimeout(resolve, 0)
      }).then(() => {
        const formData = pick(data, ['id', 'name', 'credit', 'cash', 'date'])
        console.log('formData', formData)
        this.id = formData.id
        form.setFieldsValue(formData)
      })
    },
    onDateChange (date, dateString) {
      console.log(date, dateString)
      this.start_date = dateString[0]
      this.end_date = dateString[1]
      this.date_change = true
    }
  }
}
</script>
